import { render } from "./IconLock.vue?vue&type=template&id=1472e8ed"
import script from "./IconLock.vue?vue&type=script&lang=js"
export * from "./IconLock.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__